/* Losse lees- en schrijfacties rond één Offerte die de pagina nodig heeft naast
 * useQuote (dat de offerte zelf en de regels beheert). */

import type { OfferteClient } from './acties';
import type { OfferteProject } from './projectmap';

/** Het project van de offerte, met de projectmap. null zonder project of als het weg is. */
export async function haalOfferteProject(client: OfferteClient, projectId: string | null): Promise<OfferteProject | null> {
  if (!projectId) return null;
  const { data, error } = await client
    .from('projects')
    .select('id, name, project_number, sharepoint_folder_path')
    .eq('id', projectId)
    .maybeSingle();
  if (error) throw error;
  return data ?? null;
}

/** Wat een kopie meeneemt: klant, traject, sjabloon, teksten, voorwaarden en de regels. Geen status, revisies of datums. */
const KOPIE_VELDEN = [
  'organization_id', 'contact_id', 'project_id', 'charging_location_id', 'charging_opportunity_id', 'template_id',
  'body', 'terms', 'pricing_mode', 'project_goal', 'work_description', 'advice_conclusion', 'disclaimer',
  'additional_conditions', 'payment_conditions', 'payment_term', 'discount_percentage', 'discount_amount', 'reference',
] as const;

/** Een nieuwe offerte (concept, revisie 1, nieuw nummer) met de inhoud van deze. Geeft het id. */
export async function dupliceerOfferte(client: OfferteClient, bron: Record<string, any>): Promise<string> {
  const { data: { user } } = await client.auth.getUser();
  if (!user) throw new Error('Niet ingelogd.');
  const { data: nummer, error: nummerFout } = await client.rpc('generate_quote_number');
  if (nummerFout) throw nummerFout;
  const kopie: Record<string, unknown> = { title: `${bron.title} (kopie)`, quote_number: nummer, owner_id: user.id, status: 'draft' };
  for (const k of KOPIE_VELDEN) if (bron[k] !== undefined) kopie[k] = bron[k];
  const { data: nieuw, error } = await client.from('quotes').insert(kopie).select('id').single();
  if (error) throw error;

  const { data: regels, error: regelFout } = await client.from('quote_line_items').select('*').eq('quote_id', bron.id).order('position');
  if (regelFout) throw regelFout;
  if (regels?.length) {
    // subtotal, vat_amount en total zijn gegenereerde kolommen; de trigger op quote_line_items
    // werkt de totalen van de offerte zelf bij.
    const { error: kopieFout } = await client.from('quote_line_items').insert(
      regels.map((r: any) => ({
        quote_id: nieuw.id, position: r.position, description: r.description, quantity: r.quantity, unit_price: r.unit_price, vat_rate: r.vat_rate,
      })),
    );
    if (kopieFout) throw kopieFout;
  }
  return nieuw.id;
}

/** Verwijderen is archiveren: deleted_at, zoals de oude lijst deed. */
export async function verwijderOfferte(client: OfferteClient, id: string): Promise<void> {
  const { error } = await client.from('quotes').update({ deleted_at: new Date().toISOString() }).eq('id', id);
  if (error) throw error;
}
